// Central page/menu access map. Change roles here only.
const RESTRICTED = ["Admin", "Accounts", "Authorizer", "Approver"];
const ADMIN_ACCOUNTS = ["Admin", "Accounts"];
const ADMIN = ["Admin"];

export const PAGE_ACCESS = {
  "/app/approvals": ["Admin", "Approver", "Authorizer", "ProjectManager", "Accounts", "Trustee"],
  // "Fund Receipts" and everything below it: Super Admin, Accounts, Authorizer only (tighter rules kept).
  "/app/fund-receipts": RESTRICTED,
  "/app/salary": ADMIN_ACCOUNTS,
  "/app/batch-pay": ADMIN_ACCOUNTS,
  "/app/reports": RESTRICTED,
  "/app/monthly-grid": RESTRICTED,
  "/app/ageing": RESTRICTED,
  "/app/cash-statement": RESTRICTED,
  "/app/utilisation-certificate": ADMIN_ACCOUNTS,
  "/app/masters": ADMIN_ACCOUNTS,
  "/app/employees": RESTRICTED,
  "/app/users": ADMIN,
  "/app/migration": ADMIN_ACCOUNTS,
  "/app/budget-admin": ADMIN,
  "/app/uc-templates": ADMIN,
  "/app/needs-review": ADMIN,
  "/app/reports/rejected-review": ADMIN,
  "/app/reports/self-disbursed": ADMIN,
  "/app/settings/sla": ADMIN,
  "/app/cron": ADMIN,
};

export const userRoles = (user) => [user?.role, ...(user?.roles || [])].filter(Boolean);

// Role permissions (mirrors backend routers/_deps.py ROLE_PERMISSIONS).
export const PERMISSIONS = {
  "milestones.manage.all_projects": ["Admin", "Authorizer", "Approver"],
};
export const hasPerm = (user, perm) => userRoles(user).some(r => (PERMISSIONS[perm] || []).includes(r));
const TRUSTEE_PAGES = ["/app", "/app/approvals", "/app/help", "/app/profile"];

export const canAccess = (user, path) => {
  const roles = userRoles(user);
  // Trustee Approver: only Dashboard, Pending on Me, Help and Profile.
  if (roles.length && roles.every(r => r === "Trustee")) return TRUSTEE_PAGES.includes(path);
  const allowed = PAGE_ACCESS[path];
  if (!allowed) return true;
  return roles.some(r => allowed.includes(r));
};
